<template>
  <div class="container">
    <div class="top-wrapper">
      <img class="top-img" :src="topImg" />
      <div class="name-box">
        <div class="name-sub">Partners</div>
        <div class="name-ch">合作伙伴</div>
      </div>
    </div>
    <div class="center-section">
      <div class="section-title">合作伙伴</div>
      <div class="center-title">
        目前公司为独立营运，欢迎国内外品牌、通路商、药局等洽谈合作。
      </div>
      <!-- <img class="center-img1" :src="centerImg1" />
      <img class="center-img2" :src="centerImg2" /> -->
    </div>
    <page-footer></page-footer>
  </div>
</template>

<script>
import pageFooter from '@/components/common/page-footer/page-footer.vue'
export default {
  name: 'home',
  components: {
    pageFooter
  },
  data() {
    return {
      topImg: require('@/assets/partners1.png'),
      centerImg1: require('@/assets/partners2.png'),
      centerImg2: require('@/assets/partners3.png')
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  text-align: left;
}

.top-wrapper {
  position: relative;

  .top-img {
    width: 100%;
    height: 1080px;
  }

  .name-box {
    position: absolute;
    top: 30%;
    transform: translateY(-50%);
    left: 10%;
    color: #fff;
    text-align: left;

    .name-sub {
      position: relative;
      font-size: 12px;
      text-align: left;
      padding: 0 16px;
      width: 50px;

      &::before {
        position: absolute;
        content: '';
        height: 1px;
        width: 15px;
        top: 50%;
        transform: translateY(-50%);
        left: -2px;
        background: #fff;
      }

      &::after {
        position: absolute;
        content: '';
        height: 1px;
        width: 15px;
        top: 50%;
        transform: translateY(-50%);
        right: -2px;
        background: #fff;
      }
    }

    .name-ch {
      margin-top: 10px;
      font-weight: bold;
      font-size: 26px;
    }
  }
}

.center-section {
  width: 60%;
  margin: auto;
  margin-top: 30px;
  color: #333;

  .center-title {
    font-weight: bold;
    font-size: 18px;
    margin-top: 20px;
  }

  .center-img1 {
    width: 100%;
    height: 80px;
    margin-top: 30px;
  }

  .center-img2 {
    width: 100%;
    height: 180px;
    margin-top: 30px;
  }
}

.section-title {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  position: relative;

  &:before {
    position: absolute;
    content: '';
    left: 0;
    width: 50px;
    height: 4px;
    background-color: #3e8cef;
    bottom: -10px;
  }
}
</style>
